import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { TermsOfUseDialogComponent } from './terms-of-use-dialog.component';
import { FocusOnFirstInvalidFieldModule } from '@go-modules/directives/focus-on-first-invalid-field';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		FormsModule,
		ReactiveFormsModule,
		GoMaterialModule,
		FocusOnFirstInvalidFieldModule
	],
	declarations: [
		TermsOfUseDialogComponent
	],
	exports: [
		TermsOfUseDialogComponent
	]
})
export class TermsOfUseDialogModule {}
